import { z } from "zod";

export const entityIdsQuerySchema = z.preprocess((value) => {
    if (value === undefined || value === null) {
        return [];
    }
    return Array.isArray(value) ? value : [value];
}, z.array(z.coerce.number()));
